module.exports = __webpack_public_path__ + "static/img/img-15.c40ed9a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img-15.png
// module id = BqwW
// module chunks = 1